import { render } from "./Home.vue?vue&type=template&id=64bfe11c&scoped=true&ts=true"
import script from "./Home.vue?vue&type=script&lang=ts"
export * from "./Home.vue?vue&type=script&lang=ts"

import "./Home.vue?vue&type=style&index=0&id=64bfe11c&scoped=true&lang=css"

import exportComponent from "/home/pk/projects/Tha_Chamber/thachamber/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-64bfe11c"]])

export default __exports__